import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { exchangeToken, setToken } from "@/lib/api";

type Status = "idle" | "exchanging" | "error";

export default function Login() {
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const [status, setStatus] = useState<Status>("idle");
  const [error, setError] = useState<string>("");

  useEffect(() => {
    const t = params.get("t");
    if (!t) return;

    setStatus("exchanging");
    exchangeToken(t)
      .then(({ access_token }) => {
        setToken(access_token);
        // Strip token from URL so reload/share doesn't replay it.
        params.delete("t");
        setParams(params, { replace: true });
        navigate("/", { replace: true });
      })
      .catch((e: unknown) => {
        setStatus("error");
        setError(e instanceof Error ? e.message : String(e));
      });
  }, [params, setParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-950 p-4">
      <div className="text-center">
        {status === "idle" && (
          <h1 className="text-xl font-medium text-zinc-300">Access denied</h1>
        )}
        {status === "exchanging" && (
          <h1 className="text-xl font-medium text-zinc-300">Verifying…</h1>
        )}
        {status === "error" && (
          <div>
            <h1 className="text-xl font-medium text-zinc-300 mb-2">Access denied</h1>
            <p className="text-xs text-zinc-600 break-all max-w-md mx-auto">{error}</p>
          </div>
        )}
      </div>
    </div>
  );
}
